var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8999 14.5483L5.45609 18.0953C6.84365 19.4736 8.39661 19.5288 9.70147 18.2239L18.5598 9.3564C19.3776 8.54775 19.3684 7.38074 18.5322 6.54453L13.4506 1.47213C12.6144 0.635919 11.4566 0.617541 10.6388 1.43537L1.78044 10.2937C0.475588 11.6077 0.521533 13.1607 1.8999 14.5483ZM11.622 2.53807C11.8609 2.29915 12.1917 2.29915 12.4214 2.52888L17.4755 7.5829C17.7052 7.81262 17.696 8.13424 17.4663 8.36397L10.5285 15.3018L4.69339 9.46667L11.622 2.53807ZM2.94746 13.5007C2.2399 12.7839 2.20314 11.9661 2.87395 11.2861L3.77448 10.3856L9.60958 16.2207L8.70904 17.1212C8.03824 17.8012 7.2204 17.7644 6.50365 17.0477L2.94746 13.5007ZM11.5364 18.6374H18.214C18.6184 18.6374 18.9492 18.3066 18.9492 17.9023C18.9492 17.498 18.6184 17.158 18.214 17.158H13.0251L11.5364 18.6374Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.800656c4e6de70a293ad50c6a8651b51.svg";
export { ForwardRef as ReactComponent };